﻿import TKModuleFactory from '@tk/utilities/tk.module.factory';
import TKManager from '@tk/basiscs/tk.manager';
import TKViewport from '@tk/basiscs/tk.viewport';
import TKFormDatepicker from '@tk/controls/tk.form.datepicker';
import TKFormElement from '@tk/controls/tk.form.element';
import TKFormValidator from '@tk/controls/tk.form.validator';
import TKDialog from '@tk/components/tk.dialog';
import TKTable from '@tk/components/tk.table';
import TKTooltip from '@tk/components/tk.tooltip';
import TKQuickOrder from '@tk/components/tk.quick.order';
import TKButtonDropdown from '@tk/controls/tk.button.dropdown';
import TKContextMenu from '@tk/components/tk.context.menu';
import TKMinibasket from '@tk/components/tk.minibasket';
import TKNavigationSidebar from '@tk/components/tk.navigation.sidebar';
import KWSearch from '@/controls/kw.search';
import KWArticleList from '@/components/kw.article.list';
import KWStock from '@/components/kw.stock';
import KWBasketButton from '@/components/kw.basket.button';
import KWTracker from '@/components/kw.tracker';
import KWAsyncContentLoader from '@/components/kw.async.content.loader';
import KWAsyncPostField from '@/components/kw.async.post.field';
import KWTabsTab from '@/components/kw.tabs.tab';
import KWBasketTile from '@/components/kw.basket.tile';
import KWTracking from '@/components/kw.tracking';
import KWDialog from '@/components/kw.dialog';
import KWTable from '@/components/kw.table';
import KWPrice from '@/components/kw.price';
import KWScan from '@/components/kw.scan';
import KWFileUploadArea from '@/components/kw.file.upload.area';
import KWSubmitDirect from '@/controls/kw.submit.direct';
import KWRemark from '@/components/kw.remark';
import KWPunchoutOciForm from '@/components/kw.punchout.oci.form';

import 'tippy.js/dist/tippy.css';
import 'flatpickr/dist/flatpickr.min.css';
import '@uppy/core/dist/style.min.css';
import '@uppy/dashboard/dist/style.min.css';
import '@scss/modules/basket.scss';

export default class Basket extends TKModuleFactory {
    constructor() {
        super([
            { name: 'tk-manager', constructor: TKManager },
            { name: 'kw-tracker', constructor: KWTracker },
            { name: 'tk-viewport', constructor: TKViewport },
            { name: 'tk-form-datepicker', constructor: TKFormDatepicker },
            { name: 'tk-form-element', constructor: TKFormElement },
            { name: 'tk-form-validator', constructor: TKFormValidator },
            { name: 'tk-dialog', constructor: TKDialog },
            { name: 'tk-table', constructor: TKTable },
            { name: 'tk-tooltip', constructor: TKTooltip },
            { name: 'kw-basket-button', constructor: KWBasketButton },
            { name: 'tk-quick-order', constructor: TKQuickOrder },
            { name: 'tk-tabs-tab', constructor: KWTabsTab },
            { name: 'tk-button-dropdown', constructor: TKButtonDropdown },
            { name: 'tk-context-menu', constructor: TKContextMenu },
            { name: 'tk-minibasket', constructor: TKMinibasket },
            { name: 'tk-article-list', constructor: KWArticleList },
            { name: 'tk-stock', constructor: KWStock },
            { name: 'kw-async-content-loader', constructor: KWAsyncContentLoader },
            { name: 'kw-async-post-field', constructor: KWAsyncPostField },
            { name: 'kw-basket-tile', constructor: KWBasketTile },
            { name: 'kw-tracking', constructor: KWTracking },
            { name: 'kw-dialog', constructor: KWDialog },
            { name: 'kw-table', constructor: KWTable },
            { name: 'tk-price', constructor: KWPrice },
            { name: 'tk-search', constructor: KWSearch },
            { name: 'kw-scan', constructor: KWScan },
            { name: 'tk-file-upload-area', constructor: KWFileUploadArea },
            { name: 'tk-nav-sidebar', constructor: TKNavigationSidebar },
            { name: 'kw-submit-direct', constructor: KWSubmitDirect },
            { name: 'kw-punchout-oci-form', constructor: KWPunchoutOciForm },
            { name: 'kw-remark', constructor: KWRemark },
        ]);
    }
}

new Basket();
